import { render, staticRenderFns } from "./MaterialManageIndex.vue?vue&type=template&id=087895de&scoped=true&"
import script from "./MaterialManageIndex.vue?vue&type=script&lang=js&"
export * from "./MaterialManageIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087895de",
  null
  
)

export default component.exports